import axios from 'axios';
import consumer from './consumer';

const subscribeToMaintenanceNotifications = async () => {
  try {
    // Verify that the role of the current user has permission to view maintenance notifications
    const response = await axios.get('/notifications/can_subscribe.json', {
      params: { notification_type: 'maintenance' },
    });
    const canSubscribe = response.data.can_subscribe;

    // Subscribe to the maintenance notifications channel
    if (canSubscribe) {
      consumer.subscriptions.create('MaintenanceNotificationsChannel', {
        connected() {
          // Called when the subscription is ready for use on the server
        },

        disconnected() {
          // Called when the subscription has been terminated by the server
        },

        received(data) {
          // Called when there's incoming data on the websocket for this channel
          const $counter = $('#notification-counter');
          const $counterLabel = $('#notification-label');
          let val;
          $('#notifications_menu').prepend(data.message);

          if ($counter.text()) {
            val = parseInt($counter.text(), 10);
          } else {
            val = 0;
          }
          val += 1;
          $counterLabel
            .css({
              opacity: 0,
            })
            .animate(
              {
                opacity: 1,
              },
              1200
            );
          $counter
            .css({
              opacity: 0,
            })
            .text(val)
            .animate(
              {
                opacity: 1,
              },
              1200
            );
        },
      });
    }
  } catch (error) {
    console.log(error);
  }
};

subscribeToMaintenanceNotifications();
